// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"c739dc79","213":"9e7bde2b","475":"1cad9929","580":"fefbbd78","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};